<div class="se-tool-upload-dicom_main-container themed-class">
    <div class="estensa-spinner" *ngIf="(uploaderService.showSpinner$ | async) || showSpinner">
        <mat-spinner></mat-spinner>
    </div>
    <div class="row align-fl-start">
        <div class="form-container">
            <patient-details-form *ngIf="showPatientForm"
                                  [patientInfo]="patientInfo"
                                  [isVNA]="isVNA"
                                  (patientChanges)="onPatientFormChange($event)">
            </patient-details-form>
        </div>
        <div class="drop-container">
            <import-file class="drop-col"
                         [acceptedTypeFile]="acceptedTypeFile"
                         (fileData)="onFileUploaded($event)">
            </import-file>
            <import-file *ngIf="_acceptFolder"
                         class="drop-col"
                         [acceptedTypeFile]="acceptedTypeFile"
                         [acceptFolder]="_acceptFolder"
                         (fileData)="loadDicomFiles($event)">
            </import-file>
        </div>
    </div>

    <div *ngIf="_data.length > 0" class="tab-container">
        <div class="table-head">
            <div class="row">
                <div class="col-action">
                    <mat-checkbox [ngModel]="checkAll"
                                  [indeterminate]="indeterminate"
                                  (ngModelChange)="toggleAll()">
                    </mat-checkbox>
                </div>
                <div class="col-action-delete"></div>
                <div class="col-pid">{{'Pid' | translate}}</div>
                <div class="col-patient">{{'Patient' | translate}}</div>
                <div class="col-description">{{'Description' | translate}}</div>
                <div class="col-acc-number">{{'Accession_Number' | translate}}</div>
                <div class="col-date">{{'Date' | translate}}</div>
                <div class="col-modality">{{'Modality' | translate}}</div>
            </div>
        </div>

        <div *ngFor="let study of _data" class="patient-container mt-2">
            <study [study]="study"
                   [check]="childrenEvent$.get(study.data.id)!"
                   [patientToMatch]="patientInfo"
                   [sending]="sendingInstances.get(study.data.id)"
                   (checked)="onChecked(study.data.id, $event)"
                   (delete)="onRemoveStudy(study.data.id)"></study>
        </div>

        <div class="btn-container">
            <button type="button" class="btn btn-primary btn-s" [disabled]="disableImportAfterAllSent() || disableUploadButton || !this.patientFormValid"
                    (click)="_uploadAll()">
                <span class="glyphicon glyphicon-upload"></span> {{ 'Import' | translate }}
            </button>
        </div>

    </div>
</div>
